<template>
  <v-tooltip
    v-model="showTooltip"
    bottom
    allow-overflow
  >
    <template v-slot:activator="{ on, attrs }">
      <a
        :id="tooltipIconId"
        class="tooltip-handle"
        v-bind="attrs"
        v-on="on"
        @click.prevent="toggleTooltip"
      >
        <span
          v-if="type === 'info'"
          class="info-tooltip"
        >i</span>
        <span v-else />
      </a>
    </template>
    <div
      ref="content"
      @click="toggleTooltip"
    >
      <div
        v-if="type != 'modal'"
        class="popover__arrow"
      />
      <h3 class="popover-title">
        <span>
          {{ title }}
        </span>
        <span
          v-if="type == 'modal'"
          class="close"
        >x</span>
      </h3>
      <div class="popover-content">
        <slot />
      </div>
    </div>
  </v-tooltip>
</template>
<script>
import { VTooltip } from 'vuetify/lib';

export default {
  components: {
    VTooltip,
  },
  props: {
    tooltipIconId: {
      type:    String,
      default: '',
    },
    title: {
      type:    String,
      default: '',
    },
    type: {
      type:    String,
      default: null,
    },
    showTooltip: {
      type:    Boolean,
      default: false,
    },
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
  },
};
</script>
<style scoped>
.popover__arrow {
  top: -7px;
  margin-left: -5px;
  border-right-color: rgba(0,0,0,0.25);
  border-top-color: rgba(0,0,0,0.25);
  border-left-color: transparent;
  border-bottom-color: transparent;
  content: "";
  border-width: 1px;
  position: absolute;
  display: block;
  width: 13px;
  height: 13px;
  transform: rotate(-45deg);
  border-style: solid;
  background-color: #f7f7f7;
  left: 50%;
}
.v-tooltip__content {
  max-width: 276px;
  padding: 1px;
  font-family: Signika, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.428571429;
  line-break: auto;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  white-space: normal;
  font-size: 16px;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0,0,0,0.2);
  border-radius: 4px;
  box-shadow: 0 5px 10px rgba(0,0,0,0.2);
  opacity: 1 !important;
  pointer-events: initial;
}
.v-tooltip__content .popover-content {
  color: #4a4a4a;
  font-size: 1rem;
  line-height: 1.4em;
  font-weight: normal;
  font-family: "Open Sans", sans-serif;
  padding: 9px 14px;
}
.v-tooltip__content .popover-title {
  padding: 8px 14px;
  margin: 0;
  background-color: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  border-radius: 3px 3px 0 0;
  color: #4a4a4a;
}

.tooltip-handle {
  position: relative;
  cursor: pointer;
}

.info-tooltip {
  border-radius: 50%;
  border: 1px solid #002647;
  background-color: #0c90ff;
  color: #ffffff;
  font-size: 14px;
  padding: 0 8px;
}
.close {
  color: #cc0000;
  cursor: pointer;
  display: block;
  float: right;
}
</style>
